import {Component, Input} from '@angular/core';

import {DetailField, DetailParams, formatValue} from '../../../../shared';
import {PERSONASCOREDETAIL_DEFAULT_FIELDS, PersonasCoreDetailParams} from '../../../models';

@Component({
  selector: 'app-persona-detail',
  templateUrl: './persona-detail.component.html',
  styleUrls: ['./persona-detail.component.scss']
})
export class PersonaDetailComponent {
  fields: DetailField[] = [];
  detailParams: DetailParams = null;

  constructor() {
  }

  _params: PersonasCoreDetailParams = null;

  @Input()
  set params(value: PersonasCoreDetailParams) {
    this._params = value;
    if (!value) {
      return;
    }
    this.fields = value.fields || PERSONASCOREDETAIL_DEFAULT_FIELDS;
    const rows = this.fields.map(f => ({
      label: f.label,
      value: formatValue(value.persona[f.name], f.format)
    }));
    this.detailParams = {
      rows
    };
  }
}
